export default __webpack_public_path__ + "static/water_mill-8e3fc46d4a274e3a9e2e8038e931d7a3.mp4";